export default "__VITE_ASSET__IafdJaDf__"